import { render, staticRenderFns } from "./createScheduleNotification.vue?vue&type=template&id=238e1742&scoped=true&"
import script from "./createScheduleNotification.vue?vue&type=script&lang=js&"
export * from "./createScheduleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e1742",
  null
  
)

export default component.exports